import React, { useEffect } from 'react';
import Stack from '@mui/material/Stack';
import { useAppDispatch, useAppSelector } from '../../../store';
import { selectNotifications } from '../../../store/general/general-slice-selectors';
import HttpFetchStatus from '@common/enums/api/http-fetch-status';
import { getNotificationSubscriptions } from '../../../store/general/general-actions';
import SubscribedLists from './SubscribedLists';
import NotificationConfiguration from './NotificationConfiguration';

const NotificationSettingsPage: React.FC = () => {
  const dispatch = useAppDispatch();

  const notificationData = useAppSelector((state) => selectNotifications(state));

  useEffect(() => {
    if (notificationData.rest.getStatus === HttpFetchStatus.Idle) {
      dispatch(getNotificationSubscriptions());
    }
  }, [dispatch, notificationData.rest.getStatus]);

  return (
    <React.Fragment>
      <Stack spacing={2} alignItems="center">
        <SubscribedLists />
        <NotificationConfiguration />
      </Stack>
    </React.Fragment>
  );
};

export default NotificationSettingsPage;
